import { gql } from '@apollo/client';

const LEDGER_ACCOUNT_COMMON_FIELDS = gql`
  fragment LedgerAccountCommonFields on LedgerAccount {
    id
    autoPostEnabled
    details
    name
    internalNotes {
      id
      author {
        id
        fullName
      }
      body
      flagged
      createdOn
    }
    role
    statementDayOfMonth
    isAutoGenerated
    accountLastFourDigits
  }
`;

// V1: lastCompletedMonth is nested in accountSettings
export const GET_LEDGER_ACCOUNT_V1 = gql`
  query getLedgerAccount($id: ID!) {
    ledgerAccount(id: $id) {
      ...LedgerAccountCommonFields
      accountSettings {
        lastCompletedMonth
      }
    }
  }
  ${LEDGER_ACCOUNT_COMMON_FIELDS}
`;

// V2: lastCompletedMonth is at root level (accountSettings doesn't have it)
export const GET_LEDGER_ACCOUNT_V2 = gql`
  query getLedgerAccount($id: ID!) {
    ledgerAccount(id: $id) {
      ...LedgerAccountCommonFields
      lastCompletedMonth
    }
  }
  ${LEDGER_ACCOUNT_COMMON_FIELDS}
`;

export const EDIT_LEDGER_ACCOUNT = gql`
  mutation editLedgerAccount($ledgerAccountId: ID!, $ledgerAccountInput: LedgerAccountInput!) {
    updateLedgerAccount(
      ledgerAccountId: $ledgerAccountId
      ledgerAccountInput: $ledgerAccountInput
    ) {
      id
      details
    }
  }
`;
